import React from 'react';
import { ExternalLink, TrendingUp, Users, Award, DollarSign } from 'lucide-react';
import { externalLinks } from '../mockData';

const Franchise = () => {
  return (
    <div className="page-container">
      {/* Header Image */}
      <section className="franchise-header-image">
        <img 
          src="https://customer-assets.emergentagent.com/job_extension-academy/artifacts/n5pae805_Franchise%20standing%20outside%20salon%20signage_20251006_181712_0007.png"
          alt="Franchise standing outside Need a Hair Makeover salon"
          className="franchise-hero-img"
        />
      </section>

      {/* Hero Section */}
      <section className="franchise-hero">
        <div className="content-wrapper">
          <h1 className="page-title">Franchise Opportunities</h1>
          <p className="page-subtitle">
            Join the Need a Hair Makeover franchise family and build a thriving business
          </p>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="section-container">
        <div className="content-wrapper">
          {/* YouTube Video */}
          <div className="franchise-video-wrapper">
            <div className="responsive-video">
              <iframe
                src="https://www.youtube.com/embed/LELw5SJeNGA"
                title="Franchise Opportunities - Need a Hair Makeover"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          <div className="franchise-intro">
            <h2 className="section-title">Why Choose Our Franchise?</h2>
            <p className="section-description">
              The hair extensions and hair loss solutions industry is experiencing unprecedented growth, valued at
              over £10 billion globally. Our proven business model, combined with comprehensive training and ongoing
              support, provides you with everything needed to succeed.
            </p>
          </div>

          <div className="benefits-grid">
            <div className="benefit-card">
              <Award className="benefit-icon" size={40} />
              <h3 className="benefit-title">Award-Winning Brand</h3>
              <p className="benefit-text">
                Partner with a UK Top 50 salon and multiple award-winning brand recognized across the industry.
              </p>
            </div>

            <div className="benefit-card">
              <Users className="benefit-icon" size={40} />
              <h3 className="benefit-title">Comprehensive Training</h3>
              <p className="benefit-text">
                Access to our globally accredited training programs and ongoing professional development.
              </p>
            </div>

            <div className="benefit-card">
              <TrendingUp className="benefit-icon" size={40} />
              <h3 className="benefit-title">Proven Business Model</h3>
              <p className="benefit-text">
                Benefit from 19 years of industry experience and a tested, profitable business framework.
              </p>
            </div>

            <div className="benefit-card">
              <DollarSign className="benefit-icon" size={40} />
              <h3 className="benefit-title">Revenue Potential</h3>
              <p className="benefit-text">
                Earn £1000+ per month with just 6 clients in this high-demand, high-margin industry.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Pre-Qualification Banner */}
      <section className="section-container" data-testid="franchise-prequal-banner-section">
        <div className="content-wrapper">
          <a
            href="https://www.qualiquiz.app/quiz/salon-franchise-candidate-pre-qualification-asses"
            target="_blank"
            rel="noopener noreferrer"
            className="franchise-prequal-banner"
            data-testid="franchise-prequal-banner"
            aria-label="Take the Salon Franchise Candidate Pre-Qualification Assessment"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_e0838653-edb4-4055-aeea-30513770ad02/artifacts/o51ykutv_are%20you%20ready%20for%20franchise.jpg"
              alt="Salon Franchise Candidate Pre-Qualification Assessment — Are you ready to own a specialist salon? Take the assessment."
              className="franchise-prequal-banner-image"
              loading="lazy"
            />
          </a>
        </div>
      </section>

      {/* What's Included */}
      <section className="section-container section-alt">
        <div className="content-wrapper">
          <h2 className="section-title text-center-content">What's Included in Your Franchise</h2>
          <div className="included-grid">
            <div className="included-item">
              <h4>Training & Certification</h4>
              <p>Complete access to all training courses and CPD accredited certifications</p>
            </div>
            <div className="included-item">
              <h4>Brand Support</h4>
              <p>Marketing materials, branding guidelines, and ongoing promotional support</p>
            </div>
            <div className="included-item">
              <h4>Business Tools</h4>
              <p>CRM systems, booking software, and operational frameworks</p>
            </div>
            <div className="included-item">
              <h4>Ongoing Mentorship</h4>
              <p>Direct support from Diane Shawe and experienced franchise partners</p>
            </div>
            <div className="included-item">
              <h4>Territory Protection</h4>
              <p>Exclusive operating territory to maximize your business potential</p>
            </div>
            <div className="included-item">
              <h4>Supply Chain Access</h4>
              <p>Preferred pricing on premium hair products and professional equipment</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-container cta-section">
        <div className="content-wrapper">
          <div className="franchise-cta">
            <h2 className="cta-title">Ready to Start Your Franchise Journey?</h2>
            <p className="cta-description">
              Visit our dedicated franchise website to learn more about investment details, success stories,
              and how to get started.
            </p>
            <a
              href={externalLinks.franchise}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary-large"
            >
              Visit Franchise Website <ExternalLink size={24} />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Franchise;